<template>
  <a-row :gutter="24">
    <a-col v-for="(item,index) in config" :key="index" :span="item.col">
      <a-form-item
        :label="item.label"
        :label-col="formItemLayout.labelCol"
        :wrapper-col="formItemLayout.wrapperCol"
      >
        <!-- input -->
        <a-input
          v-if="item.type === 'input' || item.type === 'password'"
          v-decorator="item.decorator"
          :placeholder="item.placeholder || ''"
          :maxlength="item.maxlength ? item.maxlength : null"
          :type="item.type"
        />
      </a-form-item>
    </a-col>
  </a-row>
</template>

<script>
export default {
  name: 'StandardForm',
  props: {
    config: {
      type: Array,
      required: true
    },
    formItemLayout: {
      type: Object,
      default: () => {
        return {
          labelCol: { span: 4 },
          wrapperCol: { span: 8 }
        }
      }
    }
  }
}
</script>
<style>
.ant-form-item {
  margin-bottom: 0;
}
</style>
